// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vw90B96YViovuh0JAuvI{border-right:1px solid var(--border-neutral-default);padding-left:24px;padding-right:24px}.vw90B96YViovuh0JAuvI .V4ZNbajs06AlEp_GBQGU{justify-content:center;align-items:center;height:100%;display:flex}.C1Ahynhi4Dkh5gtkLj1Q{align-content:start;gap:8px;height:320px;margin-right:-21px;padding-bottom:20px;padding-right:15px;display:grid;overflow-y:scroll}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"left": `vw90B96YViovuh0JAuvI`,
	"empty": `V4ZNbajs06AlEp_GBQGU`,
	"wrapList": `C1Ahynhi4Dkh5gtkLj1Q`
};
export default ___CSS_LOADER_EXPORT___;
